/**
 * DeputyList — deputies on an SDB box.
 * Per procedures digest §2.6: deputies = joint owners on the box record
 * (NOT a separate role; same `CustRelAdd` mechanism — Box 575 pattern proves it).
 * Waiting list DROPPED in v3.
 *
 * This component READS and displays deputies. Add-deputy flow is a separate
 * entry (dispatches `apiClient.accounts.custRelAdd` — Wave 3).
 */
import { Pill, Button } from '@/components/primitives';
import { UserPlus } from 'lucide-react';
import type { SdbDeputyRow } from '../types';

export interface DeputyListProps {
  deputies: ReadonlyArray<SdbDeputyRow>;
  canAdd: boolean;
  onAddDeputy?: () => void;
}

export function DeputyList({ deputies, canAdd, onAddDeputy }: DeputyListProps): JSX.Element {
  return (
    <div className="rsm-deputy-list">
      {deputies.length === 0 && (
        <div className="rsm-deputy-row">
          <span className="rsm-deputy-row__sub">
            No deputies on record. In ROP, deputies = joint owners (JO relationship code).
          </span>
        </div>
      )}
      {deputies.map((d) => (
        <div key={d.cifId} className="rsm-deputy-row">
          <div className="rsm-deputy-row__meta">
            <span className="rsm-deputy-row__name">{d.customerName}</span>
            <span className="rsm-deputy-row__sub">
              CIF {d.cifId} · Added {d.addedAt.slice(0, 10)} by {d.addedBy}
            </span>
          </div>
          <Pill variant={d.relationshipCode === 'JO' ? 'info' : 'muted'}>
            {d.relationshipCode === 'JO' ? 'Joint Owner' : 'Joint Tenant'}
          </Pill>
        </div>
      ))}
      {canAdd && (
        <div style={{ marginTop: 'var(--sp-4)' }}>
          <Button variant="ghost" startIcon={<UserPlus size={14} />} onClick={onAddDeputy}>
            Add deputy (joint owner)
          </Button>
        </div>
      )}
    </div>
  );
}
